import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	dropdownTrigger: {
		...shorthands.padding(0),
		color: tokens.colorNeutralForeground3,
		...ellipsis(),

		"&:hover": {
			color: tokens.colorNeutralForeground1Hover,
		},

		"&:active": {
			color: tokens.colorNeutralForeground1Hover,
		},
	},
	triggerRoot: {
		marginRight: "8px",
		...ellipsis(),
	},
	itemElipsis: {
		...ellipsis(),
	},
	missing: {
		color: tokens.colorPaletteRedBackground3,
	},
	filterCheckboxItem: {
		maxWidth: "unset",
		">:first-child": {
			order: 3,
		},
		">:last-child": ellipsis(),
	},
	triggerText: {
		fontWeight: tokens.fontWeightBold,
	},
});
